import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
  prout = 'protal';
} else {
  prout = 'protal_' + Language;
}

export function share(params) {
  return API.post("/api/" + prout + "/api/cooperate/sharePoints", params);
}

// 合作-企业列表
export function cooperateList(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/list", params);
}
// 合作-栏目列表
export function columnList(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/columnList", params);
}
// 合作-目录列表
export function directoryList(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/directoryList", params);
}
// 合作-快速链接列表
export function columnLinkList(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/columnLinkList", params);
}
// 合作-文章列表
export function articleList(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/articleList", params);
}
// 合作-新增文章
export function add(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/add", params);
}
// 合作-文章编辑get请求，获取详情
export function editGet(params) {
  return API.get("/api/" + prout + "/api/cooperateArticle/edit", {params});
}
// 合作-文章编辑post请求，保存
export function edit(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/edit", params);
}
// 合作-文章分享次数
export function sharePoints(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/sharePoints", params);
}
// 合作-文章置顶
export function topUp(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/topUp", params);
}
// 合作-文章置精华
export function setEssence(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/setEssence", params);
}
// 合作-文章删除-管理员
export function adminDel(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/adminDelete", params);
}
// 合作-文章删除-用户
export function del(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/delete", params);
}

// 合作-问答设为已解决
export function solved(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/solved", params);
}

// 合作-问答设为典型问题
export function setTypical(params) {
  return API.post("/api/" + prout + "/api/cooperateArticle/setTypical", params);
}
// 合作-详情
export function cooperateInfo(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/info", params);
}

// 合作-详情-评分
export function score(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/score", params);
}


// 合作-详情-评论列表
export function getAnsList(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/getAnsList", params);
}


// 合作-详情-举报
export function tips(params) {
  return API.post("/api/" + prout + "/api/cooperateAns/tips", params);
}

// 合作-详情-设为不可见
export function setShow(params) {
  return API.post("/api/" + prout + "/api/cooperateAns/setShow", params);
}

// 合作-详情-置精华
export function setAnsEssence(params) {
  return API.post("/api/" + prout + "/api/cooperateAns/setEssence", params);
}

// 合作-详情-点赞
export function articleLike(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/articleLike", params);
}

// 合作-详情-收藏
export function articleCollection(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/articleCollection", params);
}

// 合作-详情-评论点赞
export function ansLike(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/ansLike", params);
}

// 合作-详情-添加评论
export function ansAdd(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/ansAdd", params);
}
// 合作-详情-删除评论
export function ansDelete(params) {
  return API.post("/api/" + prout + "/api/cooperateAns/delete", params);
}
// 合作-列表-跳转外链增加浏览量
export function addExternalLinkHits(params) {
  return API.post("/api/" + prout + "/api/cooperatePc/addExternalLinkHits", params);
}






